import { EmphasizeMatchingText } from 'components/shared/EmphasizeMatchingText/EmphasizeMatchingText';
import type { EquityUnderlying } from 'models/underlying/equity';
import { FC, useContext } from 'react';

import { InputTextContext, StyledNameTD } from '../Common';

export const EquityMenuOption: FC<EquityUnderlying> = ({ name, currency, bloombergTickerCode, reutersCode }) => {
  const inputText = useContext(InputTextContext);

  return (
    <>
      <StyledNameTD>
        <EmphasizeMatchingText searchText={inputText}>{name}</EmphasizeMatchingText>
      </StyledNameTD>
      <td className="text-nowrap">{currency}</td>
      <td className="text-nowrap" data-e2e={`multi-underlying-selector-option-bbg-${bloombergTickerCode}`}>
        <EmphasizeMatchingText searchText={inputText}>{bloombergTickerCode}</EmphasizeMatchingText>
      </td>
      <td className="text-nowrap">
        <EmphasizeMatchingText searchText={inputText}>{reutersCode}</EmphasizeMatchingText>
      </td>
    </>
  );
};
